import {filePath} from "@/utils/AwsUtils";

export const openWindows = (url, oss = false) => {
    let params =
        `scrollbars=no,
        resizable=no,
        status=no,
        location=no,
        toolbar=no,
        menubar=no,
        height=1600,
        width=1200,
        top=100`;
    if (oss) {
        url = filePath(url)
    }
    open(url, null, params);
}
